'use client'

import { to } from '@/features/veluvit/lib/route'

/**
 * 레이어·토스트 같은 비컴포넌트 코드에서 화면을 옮길 때 쓰는 다리.
 * 셸이 마운트될 때 Next 라우터를 등록한다(레퍼런스 go()/back()).
 */
type Router = { push: (href: ReturnType<typeof to>) => void; back: () => void }

let router: Router | null = null

export function registerRouter(next: Router) {
  router = next
}

export function go(path: string) {
  router?.push(to(path))
}

export function back() {
  if (typeof window !== 'undefined' && window.history.length > 1) router?.back()
  else go('/')
}
